import restAPI from "../http-common";
import session from "./session";
import { trashEventsRequest, trashEventStarRequest, trashEventNoteRequest, trashEventReportRequest } from "./CancellableRequest";

class TrashEventsApi {
	getTrashEvents(params = {}) {
		trashEventsRequest.cancel();

		return restAPI({
			method: "get",
			url: "trashevents?",
			params,
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {},
			cancelToken: trashEventsRequest.generateCancelToken()
		});
	}

	starTrashEvent(id, starred) {
		trashEventStarRequest.cancel();

		return restAPI({
			method: "put",
			url: "/star-trashevent?",
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {},
			data: {
				trashevent_id: id,
				starred,
			},
			cancelToken: trashEventStarRequest.generateCancelToken()
		});
	}

	setTrashEventNote(id, note) {
		trashEventNoteRequest.cancel();

		return restAPI({
			method: "put",
			url: "/note-trashevent?",
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {},
			data: {
				trashevent_id: id,
				note,
			},
			cancelToken: trashEventNoteRequest.generateCancelToken()
		});
	}

	reportIncorrectlyLabelledTrashEvent(id, message) {
		trashEventReportRequest.cancel();

		return restAPI({
			method: "put",
			url: "/trashevent-incorrect-label?",
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {},
			data: {
				trashevent_id: id,
				message: message
			},
			cancelToken: trashEventReportRequest.generateCancelToken()
		});
	}

	getMyGoalsTrashEventItems(params = {}) {
		return restAPI({
			method: "get",
			url: "trashevents?",
			params,
			headers: session.getIdToken() ? {"Authorization": session.getIdToken()} : {}
		});
	}
}

export const TrashEventsService = new TrashEventsApi();
